var _rect, _rect2, _rect3, _circle, _circle2, _path, _path2, _rect4, _path3, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicBrandingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 140,
    viewBox: "0 0 343 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 140,
    fill: "#3098F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 96.0002,
    width: 295,
    height: 6,
    rx: 3,
    fill: "#D9D9DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 96.0002,
    width: 107,
    height: 6,
    rx: 3,
    fill: "#FFCC00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 99.0002,
    r: 7,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 53.4997,
    r: 19.4997,
    fill: "#082C4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.891 57.9432V48.9684C167.891 48.4703 168.42 48.1502 168.861 48.3813L177.055 52.6736C177.519 52.9166 177.531 53.5764 177.077 53.8362L168.882 58.5187C168.44 58.7712 167.891 58.4521 167.891 57.9432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.191 49.0557L125.191 58.0305C125.191 58.5287 124.662 58.8487 124.221 58.6176L116.027 54.3253C115.563 54.0823 115.551 53.4225 116.005 53.1627L124.2 48.4802C124.642 48.2277 125.191 48.5468 125.191 49.0557Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.438,
    y: 59.5938,
    width: 2.43746,
    height: 12.1873,
    rx: 0.5,
    transform: "rotate(180 115.438 59.5938)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.812 57.9443V48.9695C217.812 48.4713 218.342 48.1513 218.783 48.3824L226.977 52.6747C227.441 52.9177 227.453 53.5775 226.999 53.8373L218.804 58.5198C218.362 58.7723 217.812 58.4532 217.812 57.9443Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 227.562,
    y: 47.4062,
    width: 2.43746,
    height: 12.1873,
    rx: 0.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicBrandingMobile);
export default __webpack_public_path__ + "static/media/sonic-branding-mobile.d3332e880485b0b56c355317a8ec7c8d.svg";
export { ForwardRef as ReactComponent };